import createIntentStore from "./intentStore";

const store = createIntentStore("checkout:wallet-topup");

export const savePendingTopUp = store.save;
export const readPendingTopUp = store.read;
export const takePendingTopUp = store.take;
export const clearPendingTopUp = store.clear;
